import { Box, Divider, Typography } from '@wishket/design-system';

import { formatViewCount } from '@/shared/utils';

export interface PersonalDataCountsProps {
  view: number;
  scrap: number;
  collection: number;
  highlight: number;
}

interface CountProps {
  text: string;
  count: number;
}

const PersonalDataCounts = ({
  view,
  scrap,
  collection,
  highlight,
}: PersonalDataCountsProps) => {
  const dividerClass = 'h-[52px] desktop:h-4';

  return (
    <Box className="flex items-center gap-4" data-testid="personal-data-counts">
      <CountBox text="조회" count={view} />
      <Divider isVertical className={dividerClass} />
      <CountBox text="스크랩" count={scrap} />
      <Divider isVertical className={dividerClass} />
      <CountBox text="컬렉션" count={collection} />
      <Divider isVertical className={dividerClass} />
      <CountBox text="형광펜" count={highlight} />
    </Box>
  );
};

const CountBox = ({ text, count }: CountProps) => {
  return (
    <Box className="flex flex-1 flex-col items-center tablet:flex-none desktop:flex-row desktop:gap-2">
      <Typography variant="body1" className="font-bold">
        {text}
      </Typography>
      <Typography variant="body1" className="font-bold text-primary-500">
        {formatViewCount(count)}
      </Typography>
    </Box>
  );
};

export default PersonalDataCounts;
